<template>
  <v-card color="white" flat>
    <v-row>
      <v-col  cols="8" md="8" align="center">
        <Login/>
      </v-col>
      <v-col  cols="4" md="4" align="center">
        <Links/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import Login from '../components/Login'
  import Links from '../components/Links'

  export default {
    name: 'Home',

    components: {
      Login,
      Links,
    },
  }
</script>
